import { ButtonSpinnerDimension, ButtonSpinnerMargin } from "./Button.const";
import { ButtonVariantModel } from "./Button.model";

export const checkIfButtonHasEnoughSpaceForSpinner = (
  buttonWidth: number,
  buttonLabelWidth: number,
  buttonVariant: ButtonVariantModel,
  hasOnlyIconOnLeftPosition: boolean,
  hasIconInRightPosition: boolean,
) => {
  if (hasOnlyIconOnLeftPosition) {
    return false;
  }
  if (hasIconInRightPosition) {
    return true;
  }
  const calculatedEmptySpace =
    buttonWidth -
    buttonLabelWidth -
    ButtonSpinnerMargin * 2 -
    ButtonSpinnerDimension[buttonVariant];
  return (
    calculatedEmptySpace >=
    ButtonSpinnerDimension[buttonVariant] + ButtonSpinnerMargin
  );
};
